module.exports = __webpack_public_path__ + "img/main_menu_title_Logo.74c3dbe2.png";